import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromDeviceSharing from './reducers/device-sharing.reducer';
import { DeviceSharingEffects } from './effects/device-sharing.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('DeviceSharing', fromDeviceSharing.reducer),
    EffectsModule.forFeature([DeviceSharingEffects])
  ]
})
export class DeviceSharingModule { }
